module.exports = __webpack_public_path__ + "img/icons-sprite.3d76bac4.svg";